/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_5_P2Inputs */

const en_terms_section_5_p2 = /** @type {(inputs: Terms_Section_5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who owns what we build for you is set out in the project agreement. Unless that agreement says otherwise in writing, the rights to custom work pass to the client on full payment.`)
};

const lv_terms_section_5_p2 = /** @type {(inputs: Terms_Section_5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Īpašumtiesības uz izveidoto risinājumu nosaka projekta vienošanās. Ja vienošanās dokumentā rakstiski nav noteikts citādi, tiesības uz izstrādāto risinājumu pāriet klientam pēc pilnas samaksas.`)
};

/**
* | output |
* | --- |
* | "Who owns what we build for you is set out in the project agreement. Unless that agreement says otherwise in writing, the rights to custom work pass to the cl..." |
*
* @param {Terms_Section_5_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_5_p2 = /** @type {((inputs?: Terms_Section_5_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_5_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_5_p2(inputs)
	return en_terms_section_5_p2(inputs)
});